import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { StateService } from '../../../services';
import { IGlobalSearchParam } from '../../../../shared/models/Global-Search.model';
import { Table } from 'primeng/table';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import {DialogService} from 'primeng/dynamicdialog';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { StateViewModalComponent } from '../state-view-modal/state-view-modal.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { State } from '../../../../admin/models';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../../shared/services/shared.service';
import * as fs from 'file-saver';

@Component({
  selector: 'app-state-search',
  templateUrl: './state-search.component.html',
  styleUrls: ['./state-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class StateSearchComponent implements OnInit {
  //currentUser;
  showTopFilters: boolean;
  showFilters:boolean;
  showSorting:boolean;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showAddRuleButton:boolean = false;
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  startSearch: boolean = false;
  stateList;
  gridSpinner = 'gridSpinner1';
  stateSearchSpinner = 'stateSearchSpinner';
  isSearchLoading: boolean = false;
  loading: boolean = false;
  stateSearchParam:IGlobalSearchParam;
  items: MenuItem[];
  isStateAdd : boolean = false;
  isStateEdit : boolean = false;
  buttonLabel: string = "";
  title: string = "";
  stateForm:FormGroup;
  ref: DynamicDialogRef;
  dialogPosition = 'topright';
  selectedGridMenuItem:any = null;
  showToggle:boolean;
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;
  isshowpaginator:boolean=true;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'stateName', header: 'State Name' },
    { value: 'stateCode', header: 'State Code' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'stateName', header: 'State Name' },
    { value: 'stateCode', header: 'State Code' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private stateService:StateService,
    private _fb: FormBuilder,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public sharedService : SharedService,
    private _router: Router
  ) 
  {
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
    /*this.items = [
      {
       label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editStateDetails(this.selectedGridMenuItem.stateId)
      },
      {
       label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.stateId)
      }
   ];*/
    //this.currentUser = this.storage.retrieve('currentuser');
   
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];

    this.filterCondition=[
      {fieldName:"stateName",type:"basic"},
      {fieldName:"stateCode",type:"basic"},
      {fieldName:"isActive",type:"basic"},
      {fieldName:"createdBy",type:"basic"},
      {fieldName:"createdOn",type:"date"},
    ];
    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
    this.getStateList();
    this.statusValues=['All','Active',"Inactive"];
    this.InitialSetup();
  }
  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }
  
  InitialSetup(){
    this.stateForm = this._fb.group({
      stateId: new FormControl(0,[Validators.required]),
      stateName: new FormControl("",[Validators.required]),
      stateCode: new FormControl("",[Validators.required]),
      isActive: new FormControl(false,[Validators.required]),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }

  getStateList()
  {
    this.stateSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
    this.stateService.getAllStates(this.stateSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.stateList =data;
      //console.log(this.stateList);
      this.totalRecords = data[0].totalCount;
      this.isshowpaginator=this.stateList.length>0?true:false;
      this.spinner.hide(this.stateSearchSpinner);
     });
  }
  loadStateList(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    //console.log(event);
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getStateList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
   }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    /*if(this.sortField !== 'createdOn')
    {
      this.getStateList()
    }*/

    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getStateList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  search()
  {
    //console.log(this.filterCondition.length);
    for(let i=0;i<this.filterCondition.length;i++)
    {
      if(this.filterCondition[i].type == "checkbox")
      {
        if(this.filters[this.filterCondition[i].fieldName].value == true)
        {
          this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"true"}) 
        }
        else if (this.filters[this.filterCondition[i].fieldName].value == false){
          this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"false"}) 
        }
      }
      else {
        this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:this.filters[this.filterCondition[i].fieldName].value}) 
      }
      if(i==this.filterCondition.length-1 )
      {
        this.startSearch = true; 
      } 
    }
    if(this.startSearch == true)
    {
      this.stateSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
      this.stateService.getAllStates(this.stateSearchParam).subscribe((data: any) => {
        this.appliedFilters = [];
        this.stateList =data;
        //console.log(this.stateList);
        this.totalRecords = data[0].totalCount;
        this.isshowpaginator=this.stateList.length>0?true:false;
       });
    }
  }

  cancel(){
    this.isStateAdd = false;
    this.isStateEdit = false;
  }

  addStateDetails(){
    this.InitialSetup();
    this.isStateAdd = true;
    this.isStateEdit = false;
    this.title = "State Add";
    this.buttonLabel = "Save";
  }

  editStateDetails(paramId: number)
  { 
    this.InitialSetup();
    this.isStateEdit = true;
    this.isStateAdd = false;
    this.title = "State Edit";
    this.buttonLabel = "Update";
    this.stateService.getStateDetail(paramId).subscribe((data:State) =>{
      this.stateForm.patchValue(data);
    },error => {
      console.log(error)
    })
  }

  showStateDetails(paramId: number)
  {
    this.ref = this.dialogService.open(StateViewModalComponent, {
      header: 'State Details',
      width: '50%',
      contentStyle: {"max-height": "500px", "overflow": "auto"},
      baseZIndex: 10000,
      data: {id: paramId}
  });
  }

  deleteConfirm(paramId:number) {
    this.dialogPosition = 'topright';
    //console.log('deleteConfirm deleteConfirm ');
    this.confirmationService.confirm({
      message: 'Do you want to delete this state?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        //console.log("hi");
        this.stateService.deleteStateDetail(paramId).subscribe((data: any) => {
          this.getStateList();
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
         });
      },
      reject: (type) => {
        switch(type) {
            case ConfirmEventType.REJECT:
                this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
            break;
            case ConfirmEventType.CANCEL:
                this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
            break;
        }
      },
      key: "positionDialog"
    });
  }

  save({value}: {value: State}){
    //console.log(value);
    //console.log("State Id value is "+value.stateId);
    if(value.stateId == 0){
      value.createdBy = 1;
      value.createdOn = new Date();
      this.stateService.postStateDetail(value).subscribe(data => {
        this.getStateList();
        this.isStateAdd = false;
      }, error => {
        console.log(error)
      })
    }else{
      //console.log("Edit");
      this.stateService.updateStateDetail(value.stateId, value).subscribe(data => {
        this.getStateList();
        this.isStateEdit = false;
      }, error => {
        console.log(error);
      })
    }
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    // this.applyFilter();
    this.selectedStatusId = [];
    this.selectedStatus= [];
    this.getStateList();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter()
  {
    //console.log(this.filterCondition.length);
    //console.log(this.filterCondition);
    //console.log(this.filters);
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        /*else if (this.filterCondition[i].type == "basic") {
          //console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            //console.log(this.filters[this.filterCondition[i].fieldName] );
            if (this.filters[this.filterCondition[i].fieldName].value !== null) {
              //console.log("filter field name is "+[this.filterCondition[i].fieldName]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName].matchMode,
                value: this.filters[this.filterCondition[i].fieldName].value
              })
            }
          }
        }*/
        else if (this.filterCondition[i].type == "basic") {
          //console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              //console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
              if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                this.appliedFilters.push({
                  field: this.filterCondition[i].fieldName,
                  matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                  value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                })
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
    }
    }

    if(this.startSearch == true || this.startSearch == false)
    {
      this.stateSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
      this.spinner.show(this.stateSearchSpinner);
      this.stateService.getAllStates(this.stateSearchParam).subscribe((data: any) => {
      this.stateList =data;
      //console.log(this.stateList);
      if(data[0]!=undefined)
      {
        this.totalRecords = data[0].totalCount;
        this.isshowpaginator=this.stateList.length>0?true:false;
      }
      else
      {
        this.isshowpaginator=false;
      }
      
      this.spinner.hide(this.stateSearchSpinner);
      });
    }
  }

  exportState() {
    this.applyFilter();
    this.stateSearchParam = 
     {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
     };
     this.stateService.ExportStateResult(this.stateSearchParam).subscribe(res => {
     var blob = new Blob([res.body], { type: res.body.type });
     const file = new File([blob],"State.xlsx", { type: res.body.type });
     fs.saveAs(file);
     });
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      //console.log("length is "+tempColumn.length);
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label:'Edit',
       icon:'pi pi-fw pi-pencil',
       command: e => this.editStateDetails(this.selectedGridMenuItem.stateId)
      }
      this.items.push(editItem)
    }
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.stateId)
       }
       this.items.push(deleteItem);
    }
  }

 getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }
}
